import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import AddIcon from '@material-ui/icons/Add'
import FilterListIcon from '@material-ui/icons/FilterList'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import ButtonToolbar from '../../components/ButtonToolbar'
import { TransfersActionTypes } from '../../store/transfers/transfersTypes'
import useTypedSelector from '../../hooks/useTypedSelector'
import {
  setFilters,
  getTransfers,
} from '../../store/transfers/transfersActions'
import moment from 'moment'
import { useMediaQuery } from '@material-ui/core'

export default function TransfersToolbar() {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width: 600px)')
  const { filters } = useTypedSelector(({ transfersState }) => ({
    filters: transfersState.filters,
  }))

  const [state, setState] = useState({
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
  })

  const [isOpenModalFilter, setOpenModalFilter] = useState(false)

  useEffect(() => {
    setState(filters)
  }, [filters, isOpenModalFilter])

  const onChangeFilterState = (key: string) => (e: any) => {
    setState({ ...state, [key]: e.target.value })
  }

  const onClickApply = () => {
    dispatch(setFilters(state.dateTo, state.dateFrom))
    setOpenModalFilter(false)
    dispatch(getTransfers())
  }

  return (
    <>
      <ButtonToolbar
        text="Novo cadastro"
        matches={matches}
        IconLeft={AddIcon}
        onClick={() => dispatch({ type: TransfersActionTypes.EDITING_START })}
      />
      <ButtonToolbar
        text="Filtrar"
        matches={matches}
        IconLeft={FilterListIcon}
        onClick={() => setOpenModalFilter(true)}
      />

      <Dialog
        onClose={() => setOpenModalFilter(false)}
        open={isOpenModalFilter}
      >
        <DialogTitle>Filtros</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            label="Data inicial"
            value={
              state.dateFrom ||
              setState({ ...state, dateFrom: moment().format('YYYY-MM-DD') })
            }
            onChange={onChangeFilterState('dateFrom')}
          />
          <TextField
            type="date"
            label="Data final"
            value={
              state.dateTo ||
              setState({ ...state, dateTo: moment().format('YYYY-MM-DD') })
            }
            onChange={onChangeFilterState('dateTo')}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalFilter(false)}>Cancelar</Button>
          <Button
            onClick={onClickApply}
            color="primary"
            disabled={!state.dateFrom || !state.dateTo}
          >
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
